module.exports = __webpack_public_path__ + "static/img/Maestro.680c079f.svg";